import ReactExport from 'react-export-excel';
import { participants } from "../../data";
const ExcelFile = ReactExport.ExcelFile
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet


export default function Download() {
    return (
        <ExcelFile element={<button style = {{padding:'12px 35px', width:'100%'}}>Download</button>}>
            <ExcelSheet data={participants} name="Report">
                <ExcelColumn label="Participants" value="name" />
                <ExcelColumn label="Completed Sessions" value="completed_sessions" />
                <ExcelColumn label="Quiz Completed" value="quiz_completed" />
                <ExcelColumn label="Live Class Attended" value="live_class_attended" />
                <ExcelColumn label="Score Level" value="score_level" />
                <ExcelColumn label="Points Earned" value="points_earned" />
                <ExcelColumn label="Certificates" value="certificates" bold = 'true' />
            </ExcelSheet>
        </ExcelFile>
    );
}

// const data = [
//     {
//       columns: [
//         { value: "Participants" },
//         { value: "Completed Sessions" },
//         { value: "Quiz Completed" },
//         { value: "Live Class Attended" },
//         { value: "Score Level" },
//         { value: "Points Earned" },
//         { value: "Certificates" },
//       ],
//       data: participants.map((member) => {
//         return [
//           { value: member.name },
//           { value: member.completed_sessions },
//           { value: member.quiz_completed},
//           { value: member.live_class_attended },
//           { value: member.score_level },
//           { value: member.points_earned },
//           { value: member.certificates },
//         ];
//       }),
//     },
//   ];
// export default function Download() {
//     return (
//         <ExcelFile>
//             <ExcelSheet dataSet={data}/>    
//         </ExcelFile>
//     );
// }